import { Navigate } from "react-router-dom";

const ProductsPage = () => {
  return <Navigate to="/the-collection" replace />;
};

export default ProductsPage;
